let [BaseStartPanel, StartPanelEvent] = unpack(require("clover/panel/StartPanel"))
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
let StartPanel = xClass("MysteryIslandStartPanel", BaseStartPanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/start_start_main.csb")
})

StartPanel.show = function (levelId, initPropConfig, scoreConfig, levelInfo, onSuccess, onFail, onCancel, useEnergyPropId, useComplementStarPropId, isReplay) {
    function success() {
        //  检查是否获取到后端传来的配置
        if (initPropConfig.length < 2) {
            if (onFail) {
                onFail()
            }
            Toast.make(getText("未能获取到关卡道具信息\n请稍后再试"), null, () => {})
            //  未获取到关前道具配置，重新尝试获取
            ItemDataManager.loadPrePropData()
            return
        }
        let panel = StartPanel.create(levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId, useComplementStarPropId, isReplay)
        if (onSuccess) {
            onSuccess(panel)
        }else {
            panel.popup(true)
        }
        //冠军赛打点
        DCAssist.dc4ChampionStartLevelPanelShow(levelId) 
    }
    BaseStartPanel.tryAddActRes()
    //
    table.insert(BaseStartPanel.RES, "cocos/start_secret_title.csb");
    table.insert(BaseStartPanel.RES, "cocos/start_main_secretisland.plist");
    table.insert(BaseStartPanel.RES, "font/berlinsansfb_40_nostroke.fnt");
    //
    preloadWithLoading(BaseStartPanel.RES, ()=>{
        // 这里进行请求 神秘岛排行榜数据
        MysteryIslandManager.getInstance().getRankInfoHttp().then(()=>{
            success()
        }).catch(()=>{
            success()
        })
    }, onFail, onCancel)
}

// 活动逻辑 在这里判断是否需要使用底部 使用底部则排行榜不加载
StartPanel.isNeedUseBottom = function () {
    let lMgr = LightningRushManager.getInstance()
    if (!lMgr.isOpen()) return false
    if (lMgr.getState() == LightningRushManager.ACT_STATE.NOT_JOIN) return false
    return true
}

StartPanel.prototype.init = function (levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId) {
    var self = this
    BaseStartPanel.prototype.init.call(self,levelId, initPropConfig, scoreConfig, levelInfo, useEnergyPropId)
    this.buildMysteryRank()
    if(self.superBirdNode) {
        self.superBirdNode.x -= 4.5;
    } 
}
StartPanel.prototype.buildHelpBtn = function (btn) {
    let self = this
    let mystery_question = UIGroupButton.create(btn)
    // mystery_question.setLocalZOrder(100)
    // ButtonPushBounceAnim.create(mystery_question)
    mystery_question.on(UIButtonEvent.Click, function () {
        let str = getText("mysterious.Island.text")
        // str = "恭喜解锁新玩法神秘岛！\n\n1.萌萌团的小动物们会与你一起探索岛屿，使用他们强大的技能帮助你\n\n2.成功通过神秘岛关卡也可以增加主线关的活动进度哦，比如海滨通行证，萌萌竞速等活动\n\n3.想要找到神秘岛，就必须先通关主线关卡，否则神秘岛是会藏起来的哦~"
        let dialog = Dialog.show({type : 2, content : str, addContentY: -120, contentWidth: null,buttonNum:1,
        addPanelHeight: -300,closeCallBack: ()=>{

        }})
        // setLineHeight
        dialog.rawUI.getChildByName("txt").getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_LEFT)
        dialog.rawUI.getChildByName("txt").getVirtualRenderer().setLineHeight(40)
        dialog.rawUI.getChildByName("bg").getChildByName("innerbg").setVisible(false)
        dialog.rawUI.getChildByName("confirmBtn").setVisible(false)
        // let txt = dialog.rawUI.getChildByName("txt")
        
        // dialog.rawUI.getChildByName("txt").y = 0
    })

}



StartPanel.prototype.buildRank = function () {

}

StartPanel.prototype.buildMysteryRank = function () {
    let self = this
    if (!self.isIndexRes("packed/MysteryIslandRank.pack")){//判断资源是否在加载列表中
        return
    }
    if (!MysteryIslandManager.getInstance().isOpenRank()){
        return
    }
    let node = MysteryIslandManager.getInstance().createRankNode()
    this.mysteryRankNode = node
    this.addChild(node)
    self.mysteryExpandState = "close" //默认为非展开状态

    let size = cc.Director.getInstance().getVisibleSize()
    node.setPosition(0,301)
    node.setLocalZOrder(999)

    // node.getChildByName("team2").setVisible(false)
    let team2 = node.getChildByName("team2")
    let team1 = node.getChildByName("team1")
    team1.setLocalZOrder(1)
    // team1.setVisible(false)

    let mask = ccui.Scale9Sprite.createWithSpriteFrameName("mysterious_masterlist/masterlist_bg2.png", cc.rect(20, 20, 30, 30))
    mask.width = 620
    mask.height = 920
    let clip = cc.ClippingNode.create(mask)
    clip.setAlphaThreshold(0.1)
    clip.setCascadeOpacityEnabled(true)
    clip.setInverted(true);
    team2.removeFromParent(true);
    clip.addChild(team2)
    node.addChild(clip);
    clip.setName("clip")
    team1.y = -700
    // team1.x = 150
    // team2.y = -990
    // team2.setVisible(false)
    // team1.y += 10
    self.mysteryClip = clip
    self.mysteryTeam2 = team2

    let moveTime = 0.3
    let moveDis = 595

    clip.y = -416 + 50
    team2.y = 0 - 50

    // clip.y = -376 + 20
    // team2.y = -40 - 20

    let arrow_btn = UIGroupButton.create(team1.getChildByName("masterlist_btn"))
    // ButtonPushBounceAnim.create(arrow_btn)
    arrow_btn.setSwallowTouches(true);

    arrow_btn.on(UIButtonEvent.Click, function () {
        if (self.waitingPanelAnim) return
        if (self.mysteryExpandState != "close"){
            return
        }
        MysteryIslandManager.getInstance().dcRankClick(self.mysteryRankNode.session,"down")
        MysteryIslandManager.getInstance().dcRankDetailShow(self.mysteryRankNode.session)
        
        self.mysteryExpandState = "run"
        self.mysteryClip.setVisible(true)

        let actionAll = cc.Sequence.create(
            cc.MoveTo.create(moveTime, cc.p( self.x,self.y+moveDis)), 
            cc.CallFunc.create(function(){
                clip.y += 300
                team2.y -= 300
                // team1.setVisible(false)
                team1.getChildByName("masterlist_bg").setVisible(false)
                // team2.setVisible(true)
                // team2.removeFromParent(true);
                // node.addChild(team2)
                self.mysteryExpandState = "open"
                // self.mysteryRankNode.showListUI()
                if (self.mysteryRankNode){
                    self.mysteryRankNode.closeBounceEnabled()
                }
            })
        )
        arrow_btn.setVisible(false)
        team2.runAction(cc.MoveTo.create(moveTime, cc.p( team2.x,team2.y - moveDis)))
        self.runAction(actionAll)
        self.mysteryRankNode.showListUI()  

    })

    let arrow_btn_down = UIGroupButton.create(self.mysteryTeam2.getChildByName("masterlist_btn"))
    arrow_btn_down.on(UIButtonEvent.Click, function () {
        if (self.waitingPanelAnim) return
        self.takeInAnim()
    })
    if (MysteryIslandManager.getInstance().isRankGuide()){
        MysteryIslandManager.getInstance().saveRankGuide()
        MysteryIslandManager.getInstance().showExhibitionExplainPanel(()=>{
        })
    }
}

StartPanel.prototype.takeInAnim = function () {
    let self = this
    if (!this.mysteryRankNode) return
    //展开状态
    if (this.mysteryExpandState != "open" ) return
    MysteryIslandManager.getInstance().dcRankDetailClick(self.mysteryRankNode.session,"dropout")
    this.mysteryExpandState = "run"
    let moveTime = 0.3
    let moveDis = 595
    let team1 = this.mysteryRankNode.getChildByName("team1")
    // this.mysteryClip.setVisible(false)
    team1.getChildByName("masterlist_bg").setVisible(true)

    // this.mysteryTeam2.removeFromParent(true);
    // this.mysteryClip.addChild(this.mysteryTeam2)

    this.mysteryClip.y = -416 + 50
    this.mysteryTeam2.y = -645
    let actionAll = cc.Sequence.create(
        cc.MoveTo.create(moveTime, cc.p( self.x,self.y-moveDis)), 
        cc.CallFunc.create(function(){
            team1.getChildByName("masterlist_btn").setVisible(true)
            self.mysteryClip.setVisible(false)
            self.mysteryExpandState = "close"
        })
    )
    this.runAction(actionAll)
    this.mysteryTeam2.runAction(cc.MoveTo.create(moveTime, cc.p( this.mysteryTeam2.x,this.mysteryTeam2.y + moveDis)))

}

StartPanel.prototype.onClickEmpty = function () {
    var self = this
    if ( this.actBanner){
        this.actBanner.onClickEmpty()
    }
    //self.dispatchEvent(table([1, "name", StartPanelEvent.Close]))
    this.takeInAnim()
}

StartPanel.prototype.buildLevelInfo = function () {
    var self = this
    self.tittleNode.setVisible(false);
    self.getChildByName("start_main_bg02").setVisible(false);
    self.getChildByName("start_main_bg").setVisible(false);
    // self.getChildByName("com_close").setPosition();
    //
    let startTitle = cc.CSLoader.createNode("cocos/start_secret_title.csb");
    self.addChild(startTitle, -1);
    //
    const isHard = LevelConfigManager.getInstance().getHardLevel(self.levelId);
    const suffix = isHard ? "hard" : "normal";
    startTitle.getChildByName("secretisland_bg1").loadTexture(`start_main_secretisland/secretisland_bg1_${suffix}.png`, 1);
    startTitle.getChildByName("secretisland_bg2").loadTexture(`start_main_secretisland/secretisland_bg2_${suffix}.png`, 1);
    let title = startTitle.getChildByName("secretisland_titlebg1");
    title.loadTexture(`start_main_secretisland/secretisland_titlebg1_${suffix}.png`, 1);
    //
    title.getChildByName("secretisland_title").initWithSpriteFrameName(`start_main_secretisland/secretisland_title_${suffix}.png`);
    let levelLabel = title.getChildByName("label");
    levelLabel.setColor(!isHard ? cc.c3b(108, 144, 37) : cc.c3b(245, 236, 235));
    levelLabel.setString(self.levelInfo.levelId);

    self.buildHelpBtn(startTitle.getChildByName("com_detail"));
}
module.exports = table([0, StartPanel], [0, StartPanelEvent])
